var map = {
	"./Born_at_the_End_of_the_World-01-cmpr.jpg": 7172,
	"./Odwar Vs the Shadow Queen.jpg": 7703,
	"./Soni and the life drinkers.jpg": 311,
	"./Warrior_Boy_Cover-01-cmpr.jpg": 3032,
	"./after430.jpg": 5676,
	"./beautiful_mess.jpg": 4493,
	"./cocktail_from_the_savanna.jpg": 3740,
	"./mwikali-and-the-forbidden-mask-cmpr.a68adf67.jpg": 5225,
	"./mwikali-and-the-forbidden-mask-cmpr.jpg": 6326,
	"./nairobbery-cover.jpg": 6495,
	"./rough_silk.jpg": 7538,
	"./three_bolts_from_the_blue.jpg": 6408,
	"./wandia.jpg": 2644,
	"./whispers_from_vera.jpg": 5832
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8884;